const LandingPageSelection = () => {
  const FGHGameSelectionData = [
    {
      id: 1,
      Game_Type: "Sportsbook",
      Game_Type_Title: "Sportsbook",
      Game_Type_Label: "Ultimate",
      Game_Type_Img: "/images/sportsbook-selection-img.webp",
      Game_Type_Link: "Bet Live Now",
      Game_Type_Button: "/sportsbook",
    },
    {
      id: 2,
      Game_Type: "Fishing Games",
      Game_Type_Title: "Fishing",
      Game_Type_Label: "Start",
      Game_Type_Img: "/images/fishing-selection-img.webp",
      Game_Type_Link: "Shoot Now",
      Game_Type_Button: "/slots/?category=Fishing%20Games",
    },
    {
      id: 3,
      Game_Type: "Bingo",
      Game_Type_Title: "Bingo",
      Game_Type_Label: "Lets Play",
      Game_Type_Img: "/images/bingo-selection-img.webp",
      Game_Type_Link: "Start Playing",
      Game_Type_Button: "/slots/?category=Bingo%20Games",
    },
    {
      id: 4,
      Game_Type: "Arcade",
      Game_Type_Title: "Arcade",
      Game_Type_Label: "Enter The",
      Game_Type_Img: "/images/arcade-selection-img.webp",
      Game_Type_Link: "Play To Win",
      Game_Type_Button: "/slots/?category=Arcade%20Games",
    },
  ]

  return (
    <div className="fgh-game-selection-container">
      <div className="fgh-headlines-controls">
        <h2 className="fgh-h2-style">Unique Games You must Try</h2>
      </div>
      <div className="fgh-game-selection-items">
        {FGHGameSelectionData.map((FGHSelection) => (
          <div key={FGHSelection.id} className="fgh-game-selection-item">
            <img
              src={FGHSelection.Game_Type_Img}
              alt={FGHSelection.Game_Type_Title}
              className="fgh-game-selection-bimg"
            />
            <div className="fgh-game-selection-details">
              <p className="fgh-game-selection-label">
                {FGHSelection.Game_Type_Label}
              </p>
              <h3 className="fgh-game-selection-title">
                {FGHSelection.Game_Type_Title}
              </h3>
              <a
                href={FGHSelection.Game_Type_Button}
                className="fgh-game-selection-button fgh-normal-button"
              >
                {FGHSelection.Game_Type_Link}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LandingPageSelection
